// extracted by mini-css-extract-plugin
module.exports = {"warningWrapper":"w_sG g_dk g_fp g_fy g_fs g_db g_dP g_fC","btn":"w_p g_gn g_fM g_hf g_g5"};